export const module18InitialState = {
  module18: {
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    coins: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      Bandanna: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      Hat: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PottedCactusBarrel: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      PottedCactusPrickly: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      DinoFlyingGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      DinoFlyingPurple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BackpackPurple: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      BackpackGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StegoBlue: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      StegoGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FossilSkull: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      FossilArm: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      RaptorLight: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      RaptorDark: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LongNeckGreen: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LongNeckRed: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LizardBandana: {
        unlocked: false,
        x: 0,
        y: 0,
      },
      LizardVest: {
        unlocked: false,
        x: 0,
        y: 0,
      },
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
    },
  },
};

export const Module18Reducer = (state = module18InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE18_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        Bandanna: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        Hat: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PottedCactusBarrel: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        PottedCactusPrickly: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        DinoFlyingGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        DinoFlyingPurple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BackpackPurple: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        BackpackGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StegoBlue: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        StegoGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FossilSkull: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        FossilArm: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        RaptorLight: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        RaptorDark: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LongNeckGreen: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LongNeckRed: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LizardBandana: {
          unlocked: false,
          x: 0,
          y: 0,
        },
        LizardVest: {
          unlocked: false,
          x: 0,
          y: 0,
        },
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]].unlocked = true;
              tempRewards[Object.keys(tempRewards)[j]].x = obj[i]?.x_multiplier;
              tempRewards[Object.keys(tempRewards)[j]].y = obj[i]?.y_multiplier;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[], "tokens_earned":0}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"Bandanna\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"DinoFlyingGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"DinoFlyingGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BackpackPurple\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"LongNeckRed\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module18: {
          ...state.module18,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
          coins: JSON.parse(tempObj)?.tokens_earned,
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module18InitialState,
      };
    }
    case 'MODULE18_SET_DAY': {
      return {
        ...state,
        module18: {
          ...state.module18,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE18_SET_GameDetials': {
      return {
        ...state,
        module18: {
          ...state.module18,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE18_SET_stepCompleted': {
      return {
        ...state,
        module18: {
          ...state.module18,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE18_SET_dayCompleted': {
      return {
        ...state,
        module18: {
          ...state.module18,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE18_SET_CAMERAOPEN': {
      return {
        ...state,
        module18: {
          ...state.module18,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE18_SET_KEY': {
      return {
        ...state,
        module18: {
          ...state.module18,
          keys: action.payload,
        },
      };
    }
    case 'MODULE18_SET_COIN': {
      return {
        ...state,
        module18: {
          ...state.module18,
          coins: action.payload,
        },
      };
    }
    case 'MODULE18_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module18: {
          ...state.module18,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE18_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module18: {
          ...state.module18,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE18_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module18: {
          ...state.module18,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE18_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module18: {
          ...state.module18,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE18_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module18: {
          ...state.module18,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE18_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module18: {
          ...state.module18,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE18_SET_REWARD11': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            Bandanna: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD11_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            Bandanna: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD12': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            Hat: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD12_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            Hat: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD21': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            PottedCactusBarrel: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD21_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            PottedCactusBarrel: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD22': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            PottedCactusPrickly: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD22_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            PottedCactusPrickly: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD31': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            DinoFlyingGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD31_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            DinoFlyingGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD32': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            DinoFlyingPurple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD32_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            DinoFlyingPurple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD41': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            BackpackPurple: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD41_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            BackpackPurple: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD42': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            BackpackGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD42_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            BackpackGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD51': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            StegoBlue: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD51_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            StegoBlue: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD52': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            StegoGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD52_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            StegoGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD61': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            FossilSkull: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD61_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            FossilSkull: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD62': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            FossilArm: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD62_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            FossilArm: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD71': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            RaptorLight: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD71_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            RaptorLight: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD72': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            RaptorDark: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD72_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            RaptorDark: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD81': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LongNeckGreen: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD81_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LongNeckGreen: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD82': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LongNeckRed: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_REWARD82_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LongNeckRed: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_PRIZE1': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LizardBandana: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_PRIZE1_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LizardBandana: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_PRIZE2': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LizardVest: {
              unlocked: action.payload,
              x: 0,
              y: 0,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_PRIZE2_POSITION': {
      return {
        ...state,
        module18: {
          ...state.module18,
          rewards: {
            ...state.module18.rewards,
            LizardVest: {
              unlocked: true,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE18_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module18: {
          ...state.module18,
          unlockedDays: {
            ...state.module18.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }

    default:
      return state;
  }
};
export default Module18Reducer;
